/******************************************************************************
**
** Copyright 2009-2021 Gunjou Inc. All rights reserved.
** Contact: Gunjou Inc. (info@gunjou.co.jp)
**
******************************************************************************/
// <![CDATA[
window.onload = function()
{
    var ua = navigator.userAgent;
    var android = "jp.co.gunjou.store.android";
    var ios = "jp.co.gunjou.store.ios";

// Show notice every device
    if( !ua.indexOf(android) )
    {
        console.log( "1" );
    }
    else if( !ua.indexOf(ios) )
    {
        console.log( "2" );
    }
    else
    {
        var n = document.getElementById( "android-display-none" );
      if( n )
          n.classList.add( "android-display" );
    }
}
// ]]>
